// Previene el comportamiento por defecto.
// Ejemplo Si tengo una card con un <Link> y quiero abrir un botón con onClick
// No ejecuta el enlace y abre el botón

export const preventBehavior = (e) => {
	e.stopPropagation();
	e.preventDefault();
};
